/*
  **Erinnerungen zwischen Renderer und Zustellung** (Plan task-reminders, Etappe 3). Der Renderer
  kennt die Daten und rechnet den Plan; zugestellt wird im Main-Prozess (Electron) bzw. im Tab
  (Web). Beide Seiten sprechen über diese Formen.
*/

/** Ein Termin, wie der Renderer ihn an die Zustellung gibt — fertig beschriftet. */
export interface ReminderNotice {
  /** `reminderId@ms` bzw. `reminderId@snooze@ms` — dieselbe Erinnerung zum selben Zeitpunkt klingelt nur einmal. */
  key: string
  reminderId: string
  taskId: string
  /** Millisekunden seit 1970 (über IPC ohne `Date`). */
  fireAt: number
  title: string
  body: string
}

export interface ReminderPlan {
  notices: ReminderNotice[]
  /**
   * Aufgaben mit Erinnerungen, die noch offen sind. Eine schon gezeigte Mitteilung einer
   * Aufgabe, die hier fehlt (erledigt, gelöscht — auch auf einem anderen Gerät), schließt die
   * Zustellung.
   */
  openTaskIds: string[]
}

export type SnoozeChoice = '15m' | '1h' | '3h' | 'tomorrow'

/** Was in einer Mitteilung angeklickt wurde — die Datenschicht im Renderer führt es aus. */
export type ReminderAction =
  | { kind: 'open'; taskId: string | null }
  | { kind: 'complete'; taskId: string }
  | { kind: 'snooze'; reminderId: string; until: number }

export const REMINDER_CHANNELS = {
  /** R → M: der neue Plan. */
  schedule: 'reminders:schedule',
  /** R → M: die wartenden Aktionen abholen (und leeren). */
  takeActions: 'reminders:take-actions',
  /** M → R: Es warten Aktionen. */
  actionsReady: 'reminders:actions-ready',
  /** R → M: eine Probe-Mitteilung. */
  test: 'reminders:test',
  /** R → M: „Auf diesem Gerät erinnern“ lesen/setzen. */
  getEnabled: 'reminders:get-enabled',
  setEnabled: 'reminders:set-enabled',
  /** R → M: das Hauptfenster nach vorn holen (Geschafft-Moment nach „Erledigen“). */
  showWindow: 'reminders:show-window',
  /** R → M: alles vergessen — beim Abmelden. */
  clear: 'reminders:clear',
} as const
